"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)({
  image: {
    height: function height(props) {
      return props.height;
    },
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: function backgroundSize(props) {
      return props.backgroundSize;
    },
    backgroundImage: function backgroundImage(props) {
      return "url(".concat(props.image, ")");
    },
    borderRadius: 5
  }
});

var GalleryImage = function GalleryImage(_ref) {
  var image = _ref.image,
      _ref$backgroundSize = _ref.backgroundSize,
      backgroundSize = _ref$backgroundSize === void 0 ? 'cover' : _ref$backgroundSize,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 352 : _ref$height;
  var classes = useStyles({
    image: image,
    backgroundSize: backgroundSize,
    height: height
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.image
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(GalleryImage);

exports["default"] = _default;